import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';

const useLearnerMileStonesInfo = (
  username,
  options = { selector: null, fallbackData: undefined }
) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = `v1/gamification/learner/milestones/details/?username=${username}`;

  const { data: learnerMileStonesInfo, ...rest } = useFetch(
    isLoggedIn && username ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(learnerMileStonesInfo || {});
  return {
    key,
    learnerMileStonesInfo: learnerMileStonesInfo || {},
    ...rest
  };
};

export default useLearnerMileStonesInfo;
